<!-- 示例页面 -->
<template>
  <div>
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">店员管理&nbsp;/&nbsp;</span>
      </div>
      <div>档案列表</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <el-table :data="list" :max-height="height - 235" header-cell-class-name="table_header_bgcolor">
            <el-table-column
              :prop="index"
              :align="item.align"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              :show-overflow-tooltip="false"
              v-for="(item,index) in columns"
              :key="index"
            >
              <template slot-scope="scope">
                <div v-if="index == 'nextRepairTime'">
                  {{scope.row.repairStatus == "finish" ||  scope.row.repairStatus == "refund" ? "" : formatDay(scope.row.nextRepairTime)}}
                </div>
                <div v-else-if="index == 'validEndTime'">{{scope.row.validDay==-1?'永久有效':
                scope.row.repairStatus == 'finish' ? formatDay(scope.row.oxLtime) : scope.row.repairStatus == 'build' || scope.row.repairStatus == 'refund' ? "" : formatDay(scope.row.validEndTime)}}</div>
                <!-- <div v-else-if="index == 'validEndTime'">
                  {{scope.row.repairStatus == "build" ? "" : formatDay(scope.row.validEndTime)}}
                </div> -->
                <div v-else>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
              <template slot-scope="scope">
                <!-- <el-link type="primary" @click="repairPage(scope.row)">修护记录</el-link> -->
                <el-link type="primary" class="ml10" @click="details(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
        </div>
      </div>
    </div>
    <detail-edit ref="detailEditForm"></detail-edit>
    <handle ref="editForm"></handle>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import detailEdit from "../../collectMoney/paperRepair/repairCheckIn";
import handle from "../../collectMoney/paperRepair/handle";

export default {
  data() {
    return {
      firstShow: false,
      statusValue: "",
      options: [],
      positionList: [],
      input: "",
      form: {},
      dialogVisible: false,
      chooseList: [],
      supplierList: [],
      columns: config.columns,
      list: [],
      url: this.$url.repairDocument.list,
      query: {
        staffId: this.$route.params.id ? this.$route.params.id : "",
        memberId: "",
        searchShopId: "",
        status: ""
      },
      height: this.$store.getters.MainHeight,
      cloneRows: {}
    };
  },
  mixins: [minxin],

  components: { detailEdit ,handle },

  computed: {},

  created() {
    console.log("this.$route.params.id: ", this.$route.params.id);
    this.totalCounts();
  },
  methods: {
    back() {
      this.$router.push(`/manage/staffManage`);
    },
    totalCounts () {
      this.$api.post(this.$url.repairDocument.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    details(row) {
      if (row.repairStatus == "handle") {
        this.$refs["editForm"].$emit("set", row);
      } else {
        this.$refs["detailEditForm"].$emit("set", row);
      }
      
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}

.mains-content {
  height: calc(100% - 72px);
  .tops-between {
    
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
  }
  .member-content-box {
    padding: 16px 16px 0;
    background: #fff;
  }
  .member-header {
    height: 88px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid @borderColor;
    .input-with-select {
      width: 404px;
      height: 48px;
      margin-right: 15px;
      margin-left: 15px;
      /deep/ .el-input__inner {
        height: 48px;
        line-height: 48px;
        padding-left: 35px;
        background: #e1e1e1;
      }
      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 48px;
      }
      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;
        .el-input__icon {
          line-height: 48px;
        }
      }
    }
  }
}
</style>

